import React from "react";

const ResultBox = ({ message, success }) => {
  return <p className="form-error-message-text">{message}</p>;
};

export default ResultBox;
